<template>
  <header v-if="visible">
    <title>KUBBER EDS | v.{{ GLOBAL.VERSION }}</title>
    <!-- Navbar -->
    <nav :class="navbarClasses">
      <!-- Left navbar links -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
        </li>
      </ul>

      <!-- Right navbar links -->
      <ul class="navbar-nav ml-auto">

        <!-- Messages Dropdown Menu -->
        <li class="nav-item dropdown ">
          <a class="nav-link" data-toggle="dropdown" href="#">
            <i class="far fa-comments"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">

            <a href="#" class="dropdown-item">
              <!-- Message Start -->
              <div class="media">
                <img src="dist/img/user8-128x128.jpg" alt="User Avatar" class="img-size-50 img-circle mr-3">
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    Sistema
                    <span class="float-right text-sm text-muted"><i class="fas fa-star"></i></span>
                  </h3>
                  <p class="text-sm">Bienvenido a sistema</p>
                  <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i>Mensaje automático</p>
                </div>
              </div>
              <!-- Message End -->
            </a>

            <div class="dropdown-divider"></div>
            <!-- <a href="#" class="dropdown-item dropdown-footer">Ver mas mensajes</a> -->
          </div>
        </li>

        <!-- Notifications Dropdown Menu -->
        <li class="nav-item dropdown">
          <a class="nav-link" data-toggle="dropdown" href="#">
            <i class="far fa-bell"></i>
            <span class="badge badge-warning navbar-badge">0</span>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <span class="dropdown-header">0 Notifications</span>
            .
          </div>
        </li>


        <!-- Profile -->
        <li class="nav-item dropdown user-menu">
          <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">
            <img src="dist/img/user2-160x160.jpg" class="user-image img-circle elevation-1" alt="User Image">
            <span class="d-none d-md-inline">{{ this.person != null ? this.person.nombres : "" }}</span>
          </a>
          <ul class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <!-- User image -->
            <li :class="['user-header', color]" style="border: 1px solid #ffffff;">
              <img src="dist/img/user2-160x160.jpg" class="img-circle elevation-2" alt="User Image">
              <p>
                {{ this.person != null ? this.person.nombres : "" }}
                <small>
                  {{ this.person != null ? this.person.nombre : "" }}
                </small>
              </p>
            </li>


            <!-- Menu Footer-->
            <li class="user-footer">
              <a href="#" class="btn btn-default btn-flat float-right">Salir</a>
            </li>
          </ul>
        </li>

      </ul>
    </nav>
    <!-- /.navbar -->

    <div>
      <!-- Main Sidebar Container -->
      <aside class="main-sidebar bg-black elevation-4">
        <!-- Brand Logo -->
        <a href="#/home" class="brand-link">
          <img src="dist/img/kubber-logo.png" alt="AdminLTE Logo" class="brand-image elevation-3">
          <span class="brand-text">
            <img src="dist/img/kubber-logo-b.png" alt="AdminLTE Logo">
          </span>
        </a>

        <!-- Sidebar -->
        <div class="sidebar">


          <!-- Sidebar Menu -->
          <nav class="mt-2">
            <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

              <li class="nav-item" v-for="item in menu" :key="item">
                <div v-if="item.disponible.includes(GLOBAL.COUNTRY)">
                  <router-link :to="item.to" class="nav-link">
                    <div v-if='item.nuevo == "S"'>
                      <i :class="item.icon"></i>
                      <p >
                        {{ item.descripcion }} 
                        <span class="right badge badge-danger">NEW</span>
                      </p>
                    </div>
                    <div v-else>
                      <i :class="item.icon"></i>
                      <p >
                        {{ item.descripcion }} 
                      </p>
                    </div>
                  </router-link>
                </div>
              </li>

            </ul>
          </nav>
          <!-- /.sidebar-menu -->
        </div>
        <!-- /.sidebar -->
      </aside>
    </div>
  </header>
</template>

<script>
import router from "../router";
import GLOBAL from '../Global.js'

export default {
  props: {
    msg: String
  },
  data() {
    return {
      GLOBAL,
      menu: [],
      menu_eds: [],
      menu_financiera: [],
      navbarClasses: '', // Inicializamos con una cadena vacía
      color: ''
    }
  },
  updated() {
    this.updateNavbarClasses();
  },

  created() {

    this.updateNavbarClasses();

    if ((typeof this.$route.params.data === "undefined")) {
      this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    } else {
      this.person = JSON.parse(this.$route.params.data);
    }


    if (this.person == null) {
      router.push("/");
    }

  },
  mounted() {
    this.reload()
  },
  computed: {
    visible() {
      this.reload()
      const publicas = ["login", "logout"]
      if (publicas.includes(this.$route.name)) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {

    updateNavbarClasses() {
      const user = JSON.parse(sessionStorage.getItem("kubber.persona"));
      var perfilUsuario = 2;
      try {
        perfilUsuario = parseInt(atob(user.perfil_id));
        GLOBAL.PERFIL = perfilUsuario
      } catch (error) {
        console.log(error)
      }

      switch (perfilUsuario) {
        case 1:
        case 2:
        case 3:
        case 8:
          this.color = 'bg-kubber';
          break;
        case 5:
          this.color = 'bg-taller';
          break;
        case 6:
          this.color = 'bg-financiera';
          break;
        default:
          this.color = 'bg-kubber';
          break;
      }

      this.navbarClasses = [
        'main-header',
        'navbar',
        'navbar-expand',
        'navbar-kubber',
        this.color,
        'navbar-dark'
      ].join(' '); // Convertimos la matriz en una cadena con clases separadas por espacios
    },



    reload() {
      if ((typeof this.$route.params.data === "undefined")) {
        this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
      } else {
        this.person = JSON.parse(this.$route.params.data);
      }

      if (this.person != null) {
        var perfil = parseInt(atob(this.person.perfil_id));
        switch (perfil) {
          case 8:
            this.menu = GLOBAL.MENU_FACTURADOR;
            break
          case 2:
            this.menu = GLOBAL.MENU_LIMIT;
            break;
          case 3:
            this.menu = GLOBAL.MENU_EDS;
            break;
          case 5:
            this.menu = GLOBAL.MENU_TALLER;
            break;
          case 6:
            this.menu = GLOBAL.MENU_FINANCIERA;
            break;
          case 9:
            this.menu = GLOBAL.MENU_FACTURADOR_ADMIN;
            break;
        }
      }

    }
  }
}
</script>

<style scoped>
.header {
  height: 50px;
  background-color: rgb(255, 217, 0);
}

.menuitem {
  min-width: 30px;
  text-align: center;
  border: 1px solid #cccccc52;
  padding: 5px;

  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  margin-right: 4px;

}

.nav-link {
  color: rgb(195, 195, 195)
}

.nav-pills .nav-link:not(.active):hover {
  color: rgb(255, 60, 0);
}

.badge{
  margin-top: 8px !important;
  font-size: 9px
}
</style>
